import NavbarLayoutComponent from "./Navbar.vue";
import TribesSelectorLayoutComponent from "./TribesSelector.vue";
import OrgDetailsLayoutComponent from "./OrgDetails.vue";
import OrgNavLayoutComponent from "./OrgNav.vue";
import OrgMembersSortLayoutComponent from "./OrgMembersSort.vue";
import ToastsContainerLayoutComponent from "./ToastsContainer.vue";

const Navbar = NavbarLayoutComponent;
const TribesSelector = TribesSelectorLayoutComponent;
const OrgDetails = OrgDetailsLayoutComponent;
const OrgNav = OrgNavLayoutComponent;
const OrgMembersSort = OrgMembersSortLayoutComponent;
const ToastsContainer = ToastsContainerLayoutComponent;

export {
  Navbar,
  TribesSelector,
  OrgDetails,
  OrgNav,
  OrgMembersSort,
  ToastsContainer,
};
